export default function initializeBoxSlider() {
    document.querySelectorAll('.box-slider').forEach((block) => {
        if (block.querySelector('.box-slider__swiper')) {
            new BoxSlider(block);
        }
    });
}

class BoxSlider {
    constructor(block) {
        this.block = block;
        this.init();
    }

    getOffsetValue(breakpoint) {
        var containerWidth = 0;

        switch (breakpoint) {
            case 0:
                containerWidth = document.body.clientWidth;
                break;
            case 576:
                containerWidth = 540;
                break;
            case 768:
                containerWidth = 720;
                break;
            case 992:
                containerWidth = 960;
                break;
            case 1200:
                containerWidth = 1140;
                break;
            case 1400:
                containerWidth = 1320;
                break;
            case 1800:
                containerWidth = 1456;
                break;
        }

        return (document.body.clientWidth - containerWidth) / 2;
    }

    init() {

        import('swiper/bundle').then(({ default: Swiper }) => {

            var timer;

            window.addEventListener('resize', () => {
                if (timer) {
                    clearTimeout(timer);
                }

                timer = setTimeout(this.initSwiper(Swiper), 200);
            });
            this.initSwiper(Swiper);

        });
    }

    initSwiper(Swiper) {
        this.block.querySelectorAll('.box-slider__swiper').forEach((slider) => {
            const pagination = this.block.querySelector('.swiper-pagination');
            const scrollbar = this.block.querySelector('.swiper-scrollbar');
            const sliderPerView = slider.dataset.items || 'auto';
            const swiper = new Swiper( slider, {
                speed: 800,
                loop: false,
                spaceBetween: 0,
                slidesPerView: sliderPerView === 'auto' ? 'auto' : parseInt(sliderPerView),
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true,
                },
                scrollbar: {
                    el: scrollbar,
                },
                navigation: {
                    nextEl: this.block.querySelector('.box-slider__arrow--next'),
                    prevEl: this.block.querySelector('.box-slider__arrow--prev'),
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesOffsetBefore: this.getOffsetValue(0),
                        slidesOffsetAfter: this.getOffsetValue(0),
                    },
                    768: {
                        slidesOffsetBefore: this.getOffsetValue(768),
                        slidesOffsetAfter: this.getOffsetValue(768),
                        slidesPerView: 'auto',
                    },
                    992: {
                        slidesOffsetBefore: this.getOffsetValue(992),
                        slidesOffsetAfter: this.getOffsetValue(992),
                    },
                    1200: {
                        slidesOffsetBefore: this.getOffsetValue(1200),
                        slidesOffsetAfter: this.getOffsetValue(1200),
                    },
                    1400: {
                        slidesOffsetBefore: this.getOffsetValue(1400),
                        slidesOffsetAfter: this.getOffsetValue(1400),
                    },
                    1800: {
                        slidesOffsetBefore: this.getOffsetValue(1800),
                        slidesOffsetAfter: this.getOffsetValue(1800),
                    },
                },
            } );
            swiper.autoplay.stop();
            new IntersectionObserver((entries, observer) => {
                // jeśli slider jest w obszarze widoczności to uruchom autoplay
                if (entries[0].isIntersecting) {
                    setTimeout(function () {
                        observer.disconnect();
                        swiper.autoplay.start();
                    }, 100);
                }
            }).observe(slider);
        });
    }
}
